// Import controller interfaces.
import { IAppLinkController } from '../Interfaces/ControllerInterfacesBarrel';
// Import base api controller.
import ApiController from './ApiController';
// Import api models.
import {
	AppLink
} from '@app/models/api';
// Import app config.
import AppConfig from '@config/app';

export default class ProductionAppLinkController extends ApiController implements IAppLinkController {

	public constructor() {
		super();
	}

	public async get(): Promise<AppLink[]> {
		return AppConfig.main_navigation_config;
	}
}